export const navigationMenu: any[] = [
    {
        title: 'Programs',
        icon: '/assets/images/programs.svg',
        routerLink: '/programs/',
    },
    {
        title: 'Materials',
        icon: '/assets/images/materials.svg',
        routerLink: '/materials/',
    },
    {
        title: 'Daily Tasks',
        icon: '/assets/images/tasks.svg',
        routerLink: '/tasks/daily-task/',
    },
    {
        title: 'Quotients',
        icon: '/assets/images/quotients.svg',
        routerLink: '/quotients/',
    },
    {
        title: 'Users',
        icon: '/assets/images/users.svg',
        routerLink: '/users/',
    },
    {
        title: 'App Feedbacks',
        icon: '/assets/images/questions.svg',
        routerLink: '/feedbacks/',
    },
    {
        title: 'Webinars',
        icon: '/assets/images/webinars.svg',
        routerLink: '/webinars/',
    },
    // {
    //     title: 'Notifications',
    //     icon: '/assets/images/notifications.svg',
    //     routerLink: '/notifications/',
    // },
    // {
    //     title: 'Affiliates',
    //     icon: '/assets/images/affiliates.svg',
    //     routerLink: '/affiliates/',
    // },
    {
        title: 'Communities',
        icon: '/assets/images/users.svg',
        routerLink: '/communities/',
    },
    // {
    //     title: 'Settings',
    //     icon: '/assets/images/settings.svg',
    //     routerLink: '/settings/',
    // }
];
